import { rootActions } from '@app-store/slices'
import { IRevealPayload } from '@app-store/slices/contacts/reveal'
import { DATA_SOURCE } from '@features/Contacts/constants'
import axios from '@utils/request'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'

interface TaskAction extends Action {
    payload: IRevealPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.contacts.reveal
function* revealSagaTask({ payload }) {
    try {
        const params = payload?.isExternal
            ? {
                  sourceName: DATA_SOURCE.Salutary,
                  externalId: payload.id
              }
            : {}
        const response = yield axios.get(`/companies/contacts/reveal/${payload.id}`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload?.sagaCB?.onSuccess(response.result)
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* revealSaga(): any {
    yield takeLatest<TaskAction>(onRequest, revealSagaTask)
}

export default revealSaga
